<template>
  <vs-row class="media-uploader">
    <vs-col vs-w="3" class="mr-2 mb-2">
      <div
        @click="selectMedia"
        class="text-center item-selector cursor-pointer"
        style=""
      >
        <feather-icon
          icon="UploadCloudIcon"
          style="color: rgba(var(--vs-success), 1)"
          svgClasses="h-10 w-10"
        /><br />
        <input
          id="file-input"
          type="file"
          accept="image/png, image/jpeg"
          name="name"
          style="display: none"
          @change="fileSelected"
        />
        Add media
      </div>
    </vs-col>
    <vs-col
      vs-w="3"
      class="mr-2"
      v-for="(media, index) in internalValue"
      :key="index"
    >
      <div class="image-item">
        <vs-button
          @click="deleteMedia(media)"
          radius
          class="deleteButton"
          color="danger"
          icon="delete"
          size="small"
        ></vs-button>

        <img v-img:todoImages :src="media" />
      </div>
    </vs-col>
  </vs-row>
</template>

<script>
export default {
  name: "MediaControllerImagesBox",
  components: {},
  directives: {},
  props: {
    value: Array,
    type: String,
  },
  data() {
    return {};
  },
  mounted() {},
  emits: ["input:value"],
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
  },
  methods: {
    async deleteMedia(mediaUrl) {
      this.internalValue = this.internalValue.filter(
        (item) => item !== mediaUrl
      );
      //await this.$store.dispatch("media/deleteMedia", mediaUrl);
    },
    async fileSelected() {
      console.log("Before upload", this.internalValue);
      const file = document.getElementById("file-input").files[0];
      let formData = new FormData();
      formData.append("attachment", file);

      const url = await this.$store.dispatch("media/uploadMedia", {
        type: this.type,
        formData: formData,
      });
      this.internalValue.push(url);
      console.log("After upload", this.internalValue);

      document.getElementById("file-input").value = null;

      //const reader = new FileReader();
      // const blob = reader.readAsDataURL(file);

      // if you want to upload multiple files at once loop
      // through the array of files

      // reader.onload = () => {
      //   console.log("File selected", reader.result);
      // };
    },
    selectMedia() {
      document.getElementById("file-input").click();
    },
  },
};
</script>


<style lang="scss" scoped>
.media-uploader {
  background-color: #f7fafc;
  padding: 15px 15px 7px 15px;
  border-radius: 7px;
}
.item-selector {
  border: 2px dashed #d5d9e0;
  border-radius: 7px;
  padding: 10px;
  color: #90a0b1;
  font-weight: bold;
  transition: all 150ms linear;
  &:hover {
    border: 2px dashed #90a0b1;
  }
}

.image-item {
  position: relative;
  height: 100px;
  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    border-radius: 7px;
  }
  .deleteButton {
    position: absolute;
    top: 5px;
    right: 5px;
    display: none;
  }
  &:hover {
    .deleteButton {
      display: block !important;
    }
  }
}
</style>